import { Box, Tag, TagColor } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

export const DisabledStatus: React.FC<{ disabled: boolean }> = ({ disabled }) => {
  const color = disabled ? TagColor.grey : TagColor.lime

  const text = disabled
    ? i18n.t('finance.chart_of_accounts.activated_status.deactivated')
    : i18n.t('finance.chart_of_accounts.activated_status.activated')

  return (
    <Box flexDirection="row" alignItems="center" gap="s8">
      <Tag type={color} showCircle>
        {text}
      </Tag>
    </Box>
  )
}
